// Where she says she "stepped away to" — atmosphere-tinted in-universe copy
// that replaces the sterile technical error banner. Each atmosphere has an
// ARRAY of possible explanations; ONE is chosen at random when the failure
// screen renders. Never concatenate multiple possibilities together.
export const STEPPED_AWAY_COPY = {
  forest_campfire: {
    lines: [
      "Maybe she's gathering firewood.",
      "Maybe she wandered down to the stream.",
      "Maybe she went to check on the horses.",
    ],
  },
  cozy_cabin: {
    lines: [
      "Maybe she's tending the hearth.",
      "Maybe she's putting the kettle on.",
      "Maybe she's fetching a blanket from upstairs.",
    ],
  },
  rainy_cabin: {
    lines: [
      "Maybe she's watching the rain.",
      "Maybe she went to close a window.",
      "Maybe she's putting the kettle on.",
    ],
  },
  seaside_cottage: {
    lines: [
      "Maybe she's walking along the shore.",
      "Maybe she's watching the tide.",
      "Maybe she went out for a moment of salt air.",
    ],
  },
  mountain_shelter: {
    lines: [
      "Maybe she stepped outside for a breath of air.",
      "Maybe she's checking the wind.",
      "Maybe she went to gather more wood.",
    ],
  },
  quiet_apartment: {
    lines: [
      "Maybe she's making some tea.",
      "Maybe she's in the other room.",
    ],
  },
  default: {
    lines: [
      "Looks like she stepped away for a little while.",
      "Maybe she needed a quiet moment.",
    ],
  },
};
